/**
 * Created by caterina on 24-05-17.
 */
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';

@Injectable()
export class NotAuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthenticationService) { }

  canActivate() {
    if (!this.authService.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/inicio']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/guards/not-authentication-guard.ts